import { Box } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

const actionBarShadowStyle = {
  shadowColor: theme.colors['surface.inverse.default'],
  shadowOffset: { width: 0, height: -6 },
  shadowOpacity: 0.08,
  shadowRadius: 16,
} as const;

const submitButtonStyle = { borderRadius: 22 } as const;

const submitButtonDisabledStyle = { backgroundColor: theme.colors['state-layer.press'] } as const;

interface FooterActionBarProps {
  disabled: boolean;
  isCommentStep: boolean;
  isLoading: boolean;
  onPress: () => void;
}

export function FooterActionBar({ disabled, isCommentStep, isLoading, onPress }: FooterActionBarProps) {
  const { t } = useTranslation('ratings');
  const insets = useSafeAreaInsets();

  return (
    <Box
      backgroundColor="surface.default"
      paddingHorizontal="spacing.general.x6"
      paddingTop="spacing.general.x2"
      style={[actionBarShadowStyle, { paddingBottom: Math.max(insets.bottom, theme.spacing['spacing.general.x4']) }]}
    >
      <Button
        disabled={disabled}
        justifyContent="center"
        loading={isLoading}
        minHeight={58}
        onPress={onPress}
        style={[submitButtonStyle, disabled && submitButtonDisabledStyle]}
        variant="primary"
      >
        <Text color="text.inverse.primary" fontWeight="700" textAlign="center" variant="bodyBase">
          {isCommentStep ? t('newRating.figmaSubmitButton') : t('newRating.figmaContinueButton')}
        </Text>
      </Button>
    </Box>
  );
}
